'use strict';

import React from 'react';

import classnames from 'classnames';
import onClickOutside from 'react-onclickoutside';

import NavigationItem from './NavigationItem';
import NavigationItems from '../definitions/NavigationItems';
import NavigationDropdown from './NavigationDropdown';
import VersionInfo from './VersionInfo';
import { getFeatures } from '../definitions/Config';
import { hpaSelector } from '../data/selector';
import { connect } from 'react-redux';
import SessionUtils from '../utils/SessionUtils';

class Navigation extends React.Component {
  handleClickOutside = () => {
    if (this.props.open && !this.props.navigationModalOpen) {
      this.props.toggleNavigation(false);
    }
  };

  handleClick = () => {
    this.props.toggleNavigation();
    window.scrollTo(0, 0);
  };

  render() {
    let { isHpa } = this.props;
    let features = getFeatures();
    let classNames = classnames('span3', 'ot-nav', {
      'ot-nav--open-mobile': this.props.open,
    });
    return (
      <>
        {this.props.open && <div className="ot-nav__overlay" />}
        <div className={classNames}>
          <div className="ot-nav__close">
            <button
              type="button"
              onClick={this.handleClickOutside}
              className="ot-nav__close__button"
            >
              &times;
            </button>
          </div>
          <ul>
            {NavigationItems(features, isHpa).map((item) => {
              if (item.type === 'custom') {
                return (
                  <NavigationDropdown
                    {...item}
                    toggleNavigationDropdown={
                      this.props.toggleNavigationDropdown
                    }
                    notifications={this.props.notifications[item.key]}
                    dropdownExtended={this.props.dropdownExtended}
                  />
                );
              }
              if (item.type === 'logout') {
                return (
                  <NavigationItem
                    {...item}
                    toggleNavigation={() => SessionUtils.logout()}
                  />
                );
              }
              return (
                <NavigationItem
                  {...item}
                  toggleNavigation={this.handleClick}
                  notifications={this.props.notifications[item.key]}
                  key={item.key}
                />
              );
            })}
          </ul>
          <VersionInfo />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { isHpa: hpaSelector(state).isHpa };
};

export default connect(mapStateToProps)(onClickOutside(Navigation));
